var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Column',{staticClass:"FlowSelectorColumn",attrs:{"title":"Flows"}},[_c('ListView',{ref:"flows",staticClass:"FlowSelectorListView",attrs:{"items":_vm.items,"showIndex":true},on:{"selected":_vm.select}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }